/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { LegacyButton } from '@zapier/design-system';

type NextButtonProps = {
  /** Disables the button. */
  disabled: boolean;
  /** Called on click. */
  onClick: () => void;
};

const Styles = {
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
};

/**
 * Renders the button to advance to the next form stage.
 */
const NextButton = ({ disabled = false, onClick }: NextButtonProps) => (
  <div css={Styles.root}>
    <LegacyButton disabled={disabled} onClick={onClick}>
      Next
    </LegacyButton>
  </div>
);

export default NextButton;
